export default "__VITE_ASSET__D2dPE5$j__"